import { render, staticRenderFns } from "./ColaE.vue?vue&type=template&id=1c0407c6&scoped=true"
import script from "./ColaE.vue?vue&type=script&lang=js"
export * from "./ColaE.vue?vue&type=script&lang=js"
import style0 from "./ColaE.vue?vue&type=style&index=0&id=1c0407c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0407c6",
  null
  
)

export default component.exports